module.exports = __webpack_public_path__ + "images/category_lp/common/icon-babble-left@2x_3e1b8d3b81fa64e9111b1f61eb71834d.png";